import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllInvoice from "../../components/user/invoice/AllInvoice";


function Invoice() {

  return (
    <>
      <AppWrapper
        pagename={"sales"}
      >
        <StyledInvoice>
          <Title
            title={"Invoice"}
            btnName={"Record Sales"}
            link={'/user/sales'}
          />
        </StyledInvoice>

        <AllInvoice />


      </AppWrapper>

    </>
  );
}

export default Invoice;

const StyledInvoice = styled.div`
  

`;